import { useParams } from "react-router-dom";
import { useAuth } from "../AuthContext";
import Chat from "../pages/Chat";

export default function ChatWrapper() {
  const { receiverId } = useParams();
  const { user, loading } = useAuth(); 

  if (loading) return <p>جاري التحميل...</p>;
  if (!user) return <p>الرجاء تسجيل الدخول</p>;

  return <Chat senderId={user.uid} receiverId={receiverId} />;
}
